var map = {
	"./cpm_client.svg": 2073,
	"./cpm_manager.svg": 2074,
	"./flow.svg": 2075
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3202;


//////////////////
// WEBPACK FOOTER
// ./components/templates/AuthenticationLayout/assets ^\.\/.*\.svg$
// module id = 3202
// module chunks = 121